import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import JasonFile from "./formLangfields.json";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import useRecorder from "../utils/useRecorder.js";
import { useNavigate } from "react-router-dom";
import {
  Microphone,
  Stop,
  Pause,
  ArrowClockwise,
  Record,
  SignOut,
} from "phosphor-react";
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png";

function HomePage() {
  const navigate = useNavigate();
  const [langCode, setLangCode] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [recorderName, setRecorderName] = useState();
  const [IsLogin, setlegalIsLogin] = useState(false);
  const [
    audioURL,
    isRecording,
    startRecording,
    stopRecording,
    pause,
    setPause,
    resume,
    setResume,
    setIsRecording,
    setReset,
  ] = useRecorder();

  useEffect(() => {
    let selectedLang = localStorage.getItem("legalLanguage");
    if (!selectedLang) {
      localStorage.setItem("legalLanguage", "en-IN");
      selectedLang = "en-IN";
    }
    const legalIsLogin = localStorage.getItem("legalIsLogin");
    setlegalIsLogin(legalIsLogin);
    setLangCode(selectedLang);
  }, []);

  const handleSearchQuery = (event) => {
    let data = event.target.value;
    if (langCode === "en-IN" || langCode === null) {
      let newd = data.replace(/[&\/\\#,+()$;~%^@_.'":*?<>{}]/g, "");
      if (newd == " ") {
        setSearchQuery("");
      } else {
        setSearchQuery(newd);
      }
    } else {
      setSearchQuery(data);
    }
  };

  React.useEffect(() => {
    const fetchText = async () => {
      let fileName = `aud.wav`;
      let fd = new FormData();
      const output = await axios({
        method: "get",
        url: audioURL,
        responseType: "blob",
      });
      let files = new File([output.data], fileName, { type: "audio/wav" });
      fd.append("file", files);
      fd.append("language", langCode);
      axios
        .post(`https://voiceapi.aicte-india.org/voice-to-text`, fd)
        .then(async (res) => {
          const textResponse = res.data;
          if (recorderName == "searchQuery") {
            setSearchQuery(textResponse.data);
          }
        });
    };
    if (audioURL !== undefined) {
      fetchText();
    }
  }, [audioURL]);

  const handleSubmit = () => {
    localStorage.setItem("legalsearchQuery", searchQuery);
    if (searchQuery !== "" && langCode !== "") {
      navigate("/lawdictionary/list");
    } else {
      alert("Language and Search Keyword not Empty");
    }
  };

  const HandleAddButton = () => {
    navigate("/lawdictionary/add-new");
  };

  const handleLogout = () => {
    localStorage.setItem("legalIsLogin", false);
    localStorage.removeItem("legaltoken");
    navigate("/lawdictionary");
    navigate(0);
  };

  const handleLogin = () => {
    navigate("/lawdictionary/login");
  };

  return (
    <>
      <div className="topDiv">
        <div className="homeheader">
          <div className="container hompageSrch">
            <div
              className="mainSrchDivIn"
              style={{ marginTop: 60, paddingLeft: 15 }}
            >
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-8 mainLogo">
                  <a href="https://anuvadini.aicte-india.org/">
                    <img src={anu_logo} alt="logo" width="210px" />
                  </a>
                  <a>
                    <img
                      src={mlj}
                      alt=""
                      width="200px"
                      style={{ marginLeft: 10 }}
                    />
                  </a>
                  <a>
                    <img
                      src={moe_logo}
                      alt=""
                      style={{ marginLeft: 10 }}
                      width="120px"
                    />
                  </a>
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                  <div className="d-flex justify-content-end align-items-center phonecenter home">
                    <button
                      className="feedbackSpn h-auto w-auto mr-3"
                      style={{ height: 36 }}
                      onClick={() => {
                        navigate("/lawdictionary");
                      }}
                    >
                      Home
                    </button>
                    <button
                      className="feedbackSpn h-auto w-auto mr-3"
                      style={{ height: 36 }}
                      onClick={() => HandleAddButton()}
                    >
                      Add New Record
                    </button>
                    <button
                      className="feedbackSpn h-auto w-auto"
                      onClick={() => {
                        navigate("/lawdictionary/home");
                      }}
                    >
                      A to Z Words
                    </button>
                    {IsLogin == "true" ? (
                      <>
                        <div className="d-flex justify-content-end buttonmargin">
                          <div className="wrapper signout">
                            <button
                              className="button w-auto"
                              onClick={() => handleLogout()}
                            >
                              <b>
                                <SignOut size={32} />
                              </b>
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="wrapper listLogin">
                          <button
                            className="button w-auto"
                            onClick={() => handleLogin()}
                          >
                            {" "}
                            <b>Login</b>
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="formSrchDiv d-flex justify-content-start form-controlhome">
                <span style={{ marginRight: 15 }}>
                  <Dropdown className="text-end">
                    <Dropdown.Toggle
                      className="selectmenu text-start p-relative w-auto"
                      variant="success"
                    >
                      {langCode ? JasonFile[0][langCode] : "Select Language"}{" "}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {Object.entries(JasonFile[0]).map((res, i) => {
                        return (
                          <Dropdown.Item
                            value={res[0]}
                            onClick={(e) => {
                              setLangCode(res[0]);
                              localStorage.setItem("legalLanguage", res[0]);
                            }}
                            key={i}
                          >
                            {res[1]}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </span>
                <div className="formInputTxt position-r">
                  <input
                    type="text"
                    name="searchQuery"
                    className="form-conrol form-control-home"
                    value={searchQuery}
                    onChange={(event) => handleSearchQuery(event)}
                  />
                  <span className="frmSrchIcn">
                    <i className="fa fa-search" aria-hidden="true"></i>
                  </span>
                  {langCode === "or-IN" ||
                  langCode === "as-IN" ||
                  langCode === "pa-IN" ? (
                    <></>
                  ) : (
                    <>
                      <div className="fromGroup scheme">
                        {isRecording && recorderName == "searchQuery" ? (
                          <React.Fragment>
                            <button
                              className="stopbutton startbutton"
                              onClick={stopRecording}
                              disabled={!isRecording}
                            >
                              <Stop size={32} weight="fill" />
                            </button>
                            {pause != false ? (
                              <>
                                <button
                                  className="stopbutton startbutton"
                                  onClick={() => {
                                    setPause(false);
                                    setResume(true);
                                  }}
                                >
                                  <Record size={32} weight="fill" />
                                </button>
                                <button
                                  className="stopbutton startbutton"
                                  onClick={() => {}}
                                  disabled={!isRecording}
                                >
                                  <ArrowClockwise size={32} weight="bold" />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="stopbutton startbutton"
                                  onClick={() => {
                                    setPause(true);
                                  }}
                                >
                                  <Pause size={20} weight="fill" />
                                </button>
                                {Text ? (
                                  <button
                                    className="stopbutton startbutton"
                                    onClick={() => {}}
                                    disabled={!isRecording}
                                  >
                                    <ArrowClockwise size={20} />
                                  </button>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </React.Fragment>
                        ) : (
                          <button
                            className="startbutton"
                            onClick={(e) => {
                              setRecorderName("searchQuery");
                              startRecording();
                            }}
                            disabled={isRecording}
                          >
                            <Microphone size={20} weight="fill" />
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="sbmtBtnDiv">
                  <button
                    type="submit"
                    className="srchBtnHm"
                    onClick={(e) => handleSubmit()}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="clearfix"></div>

      <main role="main" className="contentarea home">
        <div className="ui large breadcrumb">
          <a href="https://anuvadini.aicte-india.org/" className="section">
            Home
          </a>{" "}
          <span>/</span>
          <i className="right chevron icon divider"></i>
          <div className="active section">Law Dictionary</div>
        </div>

        <section className="abtText">
          <div className="container">
            <div className="textBox">
              <p>
                Anuvadini Law Dictionary offers access to a comprehensive and
                authentic repository of legal terminology with the ability to
                search for more than 35,000 legal words and phrases for accurate
                definitions translated in Indian regional languages.
              </p>
              <div className="homepara">
                <p>
                  <b>Instructions :</b>
                </p>
                <ul>
                  <li>
                    You can search for any Indian law in all Indian langauges.
                  </li>
                  <li>
                    Select your langauge and start seaching by typing or
                    recording on mic.
                  </li>
                  <li>
                    You can share your update on any law translation, That will
                    be also verified by a law professionals.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default HomePage;
